module.exports = __webpack_public_path__ + "static/president-fb42fd5299000fcf01eeb371618a84e2.jpg";